import { render, staticRenderFns } from "./SearchesHome.vue?vue&type=template&id=0bc35744"
import script from "./SearchesHome.vue?vue&type=script&lang=js"
export * from "./SearchesHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports